export const ADD_PRODUCT = 'productItems/AddProduct';
export const INCREMENT = 'productItems/IncrementQuantity'
export const DECREMENT = 'productItems/DecrementQuantity';
export const RESTORE_QUANTITY = 'productItems/RestoreQuantity';
